import { getSearchParams } from '@/utils/get-search-params';
import { REVIEW_STATUS, WAIT_SUBMIT_STATUS } from './constant';

const initSearch = {
  page: 1,
  'page_size': 10,
  [REVIEW_STATUS]: getSearchParams().tab || WAIT_SUBMIT_STATUS,
};
function CaseLibraryProcessSearch(state = initSearch, action) {
  if (action.type === 'SAVE_CASE_LIBRARY_PROCESS_SEARCH') {
    return { ...initSearch, ...action.payload.search };
  } else {
    return state;
  }
}
export { CaseLibraryProcessSearch };
